var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountTakeoverSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12105_26787)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.67188 12.2502C1.67179 11.4955 1.85476 10.752 2.20509 10.0835C2.55542 9.41501 3.06265 8.84146 3.6833 8.41204C4.30394 7.98262 5.01948 7.71013 5.76856 7.61795C6.51763 7.52577 7.27788 7.61664 7.98412 7.88277",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12105_26787)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9647 9.69924C13.1971 9.46686 13.3276 9.1517 13.3276 8.82307C13.3276 8.49444 13.1971 8.17928 12.9647 7.9469C12.7323 7.71453 12.4172 7.58398 12.0885 7.58398C11.7599 7.58398 11.4447 7.71453 11.2124 7.9469L8.87321 10.2872C8.73452 10.4259 8.633 10.5972 8.57804 10.7854L8.08979 12.4596C8.07515 12.5098 8.07427 12.563 8.08725 12.6136C8.10023 12.6643 8.12658 12.7105 8.16355 12.7475C8.20052 12.7844 8.24675 12.8108 8.29741 12.8238C8.34806 12.8368 8.40126 12.8359 8.45146 12.8212L10.1256 12.333C10.3138 12.278 10.4852 12.1765 10.6238 12.0378L12.9647 9.69924Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_12105_26787)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.33854 7.58333C7.94937 7.58333 9.25521 6.2775 9.25521 4.66667C9.25521 3.05584 7.94937 1.75 6.33854 1.75C4.72771 1.75 3.42188 3.05584 3.42188 4.66667C3.42188 6.2775 4.72771 7.58333 6.33854 7.58333Z",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12105_26787",
  x: 1.17188,
  y: 7.08301,
  width: 8.3125,
  height: 6.66699,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12105_26787"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12105_26787",
  x: 7.57812,
  y: 7.08398,
  width: 7.25,
  height: 7.24902,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12105_26787"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_12105_26787",
  x: 2.92188,
  y: 1.25,
  width: 7.83594,
  height: 7.83301,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12105_26787"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountTakeoverSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";